import React from 'react';
import { ArrowRight } from '@phosphor-icons/react';

/**
 * Subtle educational callout used across the Financials experience.
 * Deliberately not an alert or a marketing banner: quiet surface, restrained type.
 */
export const EducationCallout = ({ icon: Icon, title, body, ctaLabel, onOpen, testId }) => (
  <div
    className="rounded-2xl bg-[rgb(var(--background-subtle))]/70 px-5 py-5 md:px-7 md:py-6"
    data-testid={testId}
  >
    <div className="flex items-center gap-2.5">
      {Icon && <Icon size={18} className="text-primary" weight="duotone" />}
      <p className="text-sm font-medium text-slate-900">{title}</p>
    </div>
    <p className="text-sm text-foreground-muted leading-relaxed mt-2.5">{body}</p>
    <div className="mt-4 flex justify-end">
      <button
        onClick={onOpen}
        className="inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:opacity-70 active:opacity-60 transition-opacity"
        data-testid={testId ? `${testId}-cta` : undefined}
      >
        {ctaLabel}
        <ArrowRight size={14} weight="bold" />
      </button>
    </div>
  </div>
);

export default EducationCallout;
